export function calculateGreaseTrapNotesHasNextPage(
  total: number,
  limit: number,
  currentTotal: number,
) {
  const currentPage = Math.ceil(currentTotal / limit);
  const totalPages = Math.ceil(total / limit);

  return currentPage < totalPages;
}
